import type { ActionFields } from '@tribeplatform/gql-client/graphql'
import type {
  Action,
  MutationChangeHomepageArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getHomepageKey, getPageKey } from '../../utils/keys/space.key.js'

export const useChangeHomepage = (options: {
  fields?: ActionFields
  useMutationOptions?: UseMutationOptions<
    Action,
    Error,
    MutationChangeHomepageArgs
  >
}) => {
  const { fields = 'basic', useMutationOptions } = options
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, Error, MutationChangeHomepageArgs>(
    input => client.spaces.changeHomepage(input, fields),
    {
      onSuccess: (_, { type }) => {
        const pageKey = getPageKey({
          fields: 'default',
          variables: { path: '' },
        })

        const homePageKey = getHomepageKey({
          fields: 'default',
          variables: {
            type,
          },
        })

        queryClient.invalidateQueries(homePageKey)
        queryClient.invalidateQueries(pageKey)
      },
      ...useMutationOptions,
    },
  )
}
